import Rate from './Rate';
export default Rate;


//////////////////
// WEBPACK FOOTER
// ./~/rc-rate/es/index.js
// module id = 1561
// module chunks = 14